/**
 * API 基础地址与「测试环境」判断
 * 以 baseURL 为唯一配置源：.env 中设置 REACT_APP_API_BASE_URL，request 与 isTestEnv() 均据此生效
 */

const TEST_API_BASE_URL = 'https://api.tlc-testing.benaimed.com';
const DEFAULT_API_BASE_URL = 'https://api.tlc-testing.benaimed.com'; // 未设置时默认测试环境

/** 当前请求 baseURL（来自 .env REACT_APP_API_BASE_URL，未设置或空时用默认） */
const raw =
  typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL;
export const requestBaseURL: string =
  raw && String(raw).trim() ? String(raw).trim() : DEFAULT_API_BASE_URL;

/** 是否为测试环境：由 baseURL 决定，仅当指向测试 API 时为 true */
export function isTestEnv(): boolean {
  return (
    requestBaseURL === TEST_API_BASE_URL ||
    requestBaseURL.includes('tlc-testing')
  );
}
